import { CalendarPlus } from '@app/routes/organization/components/icons/calendar-plus-icon';
import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

import { Button } from '../../components';
import { useAnalytics } from '../../hooks/use-analytics';
import NoResultsFrame from '../../images/empty-series-bg.jpg';

export const NoResults = () => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  return (
    <div className="flex flex-col items-center justify-center mt-6">
      <div
        className="flex items-center justify-center h-20 w-20 rounded-[22.58px] bg-cover bg-center mb-5"
        style={{ backgroundImage: `url(${NoResultsFrame})` }}
      >
        <CalendarPlus />
      </div>
      <div className="font-inter font-semibold text-center text-lg leading-5 w-96 mb-2">
        {t('analytics.create-series-title')}
      </div>
      <div className="font-inter font-medium text-center text-sm leading-5 w-96 text-gray-750 mb-5">
        {t('analytics.create-series-description')}
      </div>
      <div className="">
        <Button
          onClick={() => {
            track('ola_seriestab_createseries_emptystate_click');
            window.location.href = window.location.href.replace(
              'analytics',
              'series',
            );
          }}
          pattern="outline"
          kind="secondary"
          size="medium"
          className="border-neutral-b4 !rounded-lg outline-none focus-visible:border-blue-500 focus-visible:outline focus-visible:ring-1 focus-visible:outline-1 focus-visible:outline-blue-500 focus-visible:outline-offset-0"
        >
          <span className={'font-medium'}>{t('analytics.create-series')}</span>
        </Button>
      </div>
    </div>
  );
};
